(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var editSearchBtns = document.querySelectorAll('#edit-search, #edit-search-bottom');
  var newSearchBtns = document.querySelectorAll('#new-search, #new-search-bottom');
  var resetSearchBtn = document.querySelector('.btn-reset');
  var sortSelect = document.getElementById('sort-results');
  var searchForm = document.getElementById('form-search-books');
  cleanUpUrl();
  sortSelect === null || sortSelect === void 0 || sortSelect.addEventListener('change', function (e) {
    changeUrlParameter('sort', e.target.value);
    window.location.reload();
  });
  editSearchBtns.forEach(function (btn) {
    return btn.addEventListener('click', function () {
      var _document$getElementB;
      showSearch();
      (_document$getElementB = document.getElementById('search')) === null || _document$getElementB === void 0 || _document$getElementB.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
  newSearchBtns.forEach(function (btn) {
    return btn.addEventListener('click', function () {
      showSearch();
      resetSearchForm();
    });
  });
  resetSearchBtn === null || resetSearchBtn === void 0 || resetSearchBtn.addEventListener('click', function () {
    resetSearchForm();
  });
  searchForm === null || searchForm === void 0 || searchForm.addEventListener('submit', function (e) {
    e.target.classList.add('loading');
  });

  // Beim Browser-Back-Restore aus dem BFCache: loading-Class entfernen,
  // sonst sieht das Formular ausgegraut/disabled aus.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      searchForm === null || searchForm === void 0 || searchForm.classList.remove('loading');
    }
  });
});
function showSearch() {
  var search = document.querySelector('.search');
  var searchTeaser = document.querySelector('.search-teaser');
  search.classList.remove('hidden');
  searchTeaser.classList.add('hidden');
}
function showSearchTeaser() {
  var search = document.querySelector('.search');
  var searchTeaser = document.querySelector('.search-teaser');
  searchTeaser.classList.remove('hidden');
  search.classList.add('hidden');
}
function resetSearchForm() {
  var searchForm = document.getElementById('form-search-books');
  window.location.search = '';
  searchForm.reset();
}
function changeUrlParameter(field, value) {
  var url = new URL(window.location.href);
  if ((value !== null && value !== void 0 ? value : null) !== null) {
    url.searchParams.set(field, value);
  } else {
    url.searchParams.delete(field);
  }
  window.history.replaceState({}, null, url);
}
function cleanUpUrl() {
  var url = new URL(window.location.href);
  url.searchParams.entries().forEach(function (param) {
    if (param[1] === '') changeUrlParameter(param[0]);
  });
  changeUrlParameter('submit'); // parameter set by yform, without function
}

},{}]},{},[1]);
